<template>
   <span :class="adminLogTypeClass(params.type)">{{ format.typeLabel(params.type) }}</span>
</template>

<script lang="ts" setup>
import { adminLogTypeClass, useAdminLogFormat } from '~/composables/adminlog'
import type { AdminLogTypeCellParams, GridCellProps } from '~/composables/grid/cell-params'

defineProps<GridCellProps<AdminLogTypeCellParams>>()

const format = useAdminLogFormat()
</script>
